import { useEffect, useState } from 'react';
import { aktiviereAppUpdate, beiAppUpdate } from '../serviceWorker';

/**
 * Kleine globale PWA-Meldung. Eine wartende Version wird nie mitten in einer
 * Übergabe erzwungen — der Nutzer entscheidet selbst zwischen Aktualisieren
 * und Später.
 */
export function AppUpdateHinweis() {
	const [sichtbar, setSichtbar] = useState(false);

	useEffect(() => beiAppUpdate(() => setSichtbar(true)), []);

	if (!sichtbar) return null;

	return (
		<aside className="app-update" role="status" aria-live="polite">
			<div>
				<strong>Neue Version verfügbar</strong>
				<span>Deine lokal gespeicherten Übergaben bleiben erhalten.</span>
			</div>
			<div className="app-update-aktionen">
				<button type="button" className="app-update-spaeter" onClick={() => setSichtbar(false)}>
					Später
				</button>
				<button type="button" className="app-update-jetzt" onClick={aktiviereAppUpdate}>
					Jetzt aktualisieren
				</button>
			</div>
		</aside>
	);
}
